import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Category } from '@features/category/interfaces/category.interface';
import { CategoryService } from '@features/category/services/category.service';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'fc-category-dropdown',
  templateUrl: './category-dropdown.component.html',
  styleUrls: ['./category-dropdown.component.css'],
})
export class CategoryDropdownComponent implements OnInit {
  faAngleRight = faAngleRight;
  categories: any = [];
  parentCategory: any = null;
  childrenCategories: any[] = [];

  constructor(
    private router: Router,
    private categoryService: CategoryService
  ) {}

  ngOnInit(): void {
    this.categoryService.getCategories().subscribe((data: any) => {
      this.categories = data.categories;
      this.selectCategoryParent(
        this.categories.filter(
          (category: Category) => category.children.length > 0
        )[0]
      );
    });
  }
  selectCategoryParent(category: Category) {
    if (category.children.length) {
      this.parentCategory = category;
      this.childrenCategories = category.children;
    } else {
      this.router.navigate(['/product'], {
        queryParams: { categories: category.slug },
      });
    }
  }

  selectCategory(category2: Category, category3: Category | null = null) {
    let categories =
      category2.slug + `${category3 ? ',' + category3.slug : ''}`;
    this.router.navigate(['/product'], {
      queryParams: { categories: categories },
    });
  }
}
